import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { NotificationService } from '../../services/notification.service';
import { SecureStorageService } from '../../services/secure-storage.service';

@Component({
  selector: 'app-payment-callback-component',
  standalone: true,
  imports: [],
  template: `<p>Vérification du paiement en cours...</p>`,
  templateUrl: './payment-callback-component.component.html',
  styleUrl: './payment-callback-component.component.scss'
})
export class PaymentCallbackComponentComponent implements OnInit {
  isLoading = true;
  paymentStatus = '';

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private http: HttpClient,
    private notificationService: NotificationService,
    private secureStorage: SecureStorageService
  ) {}

  ngOnInit() {
    this.route.queryParams.subscribe(params => {
      const reference = this.secureStorage.getItem<string>('pendingPaymentReference');
      if (!reference) {
        this.notificationService.create('Référence de paiement non trouvée', 'danger', 2000);
        this.router.navigate(['/']);
        return;
      }

      const requestData = this.secureStorage.getItem<any>('pendingRequestData');
      if (!requestData) {
        this.notificationService.create('Données de requête non trouvées', 'danger', 2000);
        this.router.navigate(['/']);
        return;
      }

      // Nettoyer les données de paiement
      this.secureStorage.removeItem('pendingPaymentReference');
      this.secureStorage.removeItem('pendingRequestData');

      // Traiter le paiement
      this.processPayment(reference, requestData);
    });
  }

  private processPayment(reference: string, requestData: any) {
    this.http.post<any>(`${environment.apiUrl}/payments/verify`, { reference })
      .subscribe({
        next: (response) => {
          this.isLoading = false;
          if (response.success) {
            this.paymentStatus = 'success';
            this.notificationService.create('Paiement effectué avec succès', 'success', 2000);
            // Rediriger vers la page appropriée
            this.router.navigate(['/payment-success']);
          } else {
            this.paymentStatus = 'failed';
            this.notificationService.create('Le paiement a échoué', 'danger', 2000);
            this.router.navigate(['/payment-failed']);
          }
        },
        error: (error) => {
          this.isLoading = false;
          this.paymentStatus = 'error';
          this.notificationService.create('Erreur lors de la vérification du paiement', 'danger', 2000);
          this.router.navigate(['/payment-failed']);
        }
      });
  }
}
